// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__d07FD","bigColWidth":"Table_bigColWidth__1eGYN","biggerColWidth":"Table_biggerColWidth__DsHML","row":"Table_row__1hZ7H","col":"Table_col__udqxY"};